import Header from './component/Header';
import './App.css';
import { Outlet } from 'react-router-dom';
import toast, {Toaster} from "react-hot-toast";
import { useEffect } from 'react';
import { setDataProduct, fetchCategories } from './redux/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import Footer from './component/Footer';
import Cookies from "js-cookie";
import { clearToken, setToken } from './redux/userSlice';
import { isTokenExpired } from './utility/authUtils';

function App() {

  const dispatch=useDispatch()
  const user = useSelector((state) => state.user);

  // Check token expiration on load and set auto-logout
  useEffect(() => {
    const checkToken = () => {
      const token = Cookies.get("token") || localStorage.getItem("token");
      
      if (token) {
        if (isTokenExpired(token)) {
          dispatch(clearToken());
          Cookies.remove("token");
          localStorage.removeItem("token");
          localStorage.removeItem("email");
          localStorage.removeItem("firstName");
          localStorage.removeItem("isAdmin");
          toast.error("Session expired, please login again");
        } else {
             // Rehydrate redux if needed (redundant if Header does it, but good safety)
             // Calculate time remaining
             const base64Url = token.split('.')[1];
             const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
             const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                 return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
             }).join(''));
             const { exp } = JSON.parse(jsonPayload);
             const timeRemaining = (exp * 1000) - Date.now();
             
             if (timeRemaining > 0) {
                 const timer = setTimeout(() => {
                     dispatch(clearToken());
                     Cookies.remove("token");
                     localStorage.removeItem("token");
                     localStorage.removeItem("email");
                     localStorage.removeItem("firstName");
                     localStorage.removeItem("isAdmin");
                     toast.error("Session expired, please login again");
                     // Optional: redirect to login
                 }, timeRemaining);
                 return () => clearTimeout(timer);
             }
        }
      }
    };

    checkToken();
    // Also run check regularly in case user leaves tab open? 
    // For now, load + timeout is sufficient for most cases.
  }, [dispatch]);

  useEffect(()=>{
    (async()=>{
      const res= await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/product`)
      const resData=await res.json()
      dispatch(setDataProduct(resData))
    })()
    // Fetch categories globally
    dispatch(fetchCategories());
  },[])
 
  return (
  <>
  <Toaster/>
  <div>
    <Header/>
    <main className='pt-20 bg-[#FFF9F2] min-h-[calc(100vh)] '>
      <Outlet/>
      <Footer/>
      </main>
      </div>
      </>
  )
}
export default App;
